var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECEDED;}\n\t.st1{fill:#C6C7C8;}\n\t.st2{fill:#28B4FF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Wind_A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.4,308.1c-31.3-1.2-55.7-27.5-54.5-58.8c1.1-30.5,26.3-54.7,56.8-54.6c0.4,0-0.8-8.9-0.8-13.6 c0-25,20.3-45.4,45.3-45.4c8.5,0,16.8,2.4,24,6.9c7.9-41,47.5-67.9,88.6-60c27.5,5.3,49.9,25.4,58,52.2 c47.6,6.2,81.2,49.8,75.1,97.4c-5.6,43.3-42.5,75.8-86.2,75.8L94.4,308.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366,170c-4.2-5.3-9-10.1-14.4-14.3l4.9-6.3c5.9,4.6,11.2,9.8,15.8,15.7L366,170z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380,176.5c-1.1-1.9-3.5-2.6-5.4-1.5c-1.9,1.1-2.6,3.5-1.5,5.4c7,12.4,10.6,26.4,10.6,40.6 c0,45.8-37.2,83-82.9,83.1H96.6c-29.1,0-52.7-23.6-52.7-52.7c0-29.1,23.6-52.7,52.7-52.7c0,0,0,0,0.1,0c14,0,27.2,5.5,37.2,15.4 c0.8,0.8,1.8,1.2,2.8,1.2c1,0,2-0.4,2.8-1.2c1.6-1.6,1.6-4.1,0-5.7c-10.5-10.5-24.3-16.7-39-17.6c0-0.5-0.1-1.1-0.1-1.7 c-0.2-2.6-0.5-5.9-0.5-8.1c0-7.7,2.2-15.3,6.3-21.9c5.9-9.4,15-15.9,25.8-18.4c10.8-2.5,21.8-0.6,31.2,5.2l4.9,3.1l1.1-5.7 c5-26.2,24-47.2,49.5-55c18.3-5.6,37.7-3.7,54.6,5.3c16.9,9,29.2,24,34.8,42.3l0.8,2.5l2.6,0.3c10.3,1.3,20.2,4.5,29.4,9.5 c1.9,1.1,4.4,0.4,5.4-1.6c1.1-1.9,0.4-4.4-1.6-5.4c-9.3-5.1-19.2-8.5-29.7-10.1c-6.5-19.2-19.9-35-37.9-44.6 c-18.8-10-40.3-12.1-60.7-5.9c-26.6,8.1-46.8,29.2-53.8,55.8c-10.1-4.8-21.4-6.1-32.4-3.6c-12.8,3-23.8,10.8-30.8,21.9 c-4.9,7.8-7.5,16.9-7.5,26.1c0,2.5,0.3,5.8,0.5,8.8c0,0.3,0.1,0.6,0.1,1C61,193,36,219.3,36,251.4c0,33.5,27.2,60.7,60.7,60.7 h204.1c50.2,0,91-40.9,90.9-91.1C391.7,205.5,387.6,190.1,380,176.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M430,256.9c-20.7,0-37.6,16.9-37.6,37.6c0,17,13.9,30.9,30.9,30.9c14.1,0,25.5-11.4,25.5-25.5 c0-11.7-9.5-21.2-21.2-21.2c-2.2,0-4,1.8-4,4s1.8,4,4,4c7.3,0,13.2,5.9,13.2,13.2c0,9.7-7.9,17.5-17.5,17.5 c-12.6,0-22.9-10.3-22.9-22.9c0-16.3,13.3-29.6,29.6-29.6c21,0,38,17,38,38c0,26.7-21.8,48.5-48.5,48.5H359H101.5h-4.9 c-2.2,0-4,1.8-4,4s1.8,4,4,4h4.9h172.3c9.4,0,17,7.6,17,17s-7.6,17-17,17c-2.2,0-4,1.8-4,4s1.8,4,4,4c13.8,0,25-11.2,25-25 c0-6.6-2.5-12.5-6.7-17H359c20.9,0,37.8,17,37.8,37.8c0,16.3-13.2,29.5-29.5,29.5c-12.6,0-22.8-10.2-22.8-22.8 c0-4.7,1.8-9,5.1-12.3c3.3-3.3,7.7-5.1,12.3-5.1c0,0,0,0,0,0c7.2,0,13.1,5.9,13.1,13.1c0,2.2,1.8,4,4,4s4-1.8,4-4 c0-11.6-9.5-21.1-21.1-21.1c0,0,0,0,0,0c-6.8,0-13.2,2.6-18,7.4c-4.8,4.8-7.5,11.2-7.5,18c0,17,13.8,30.8,30.8,30.8 c20.7,0,37.5-16.8,37.5-37.5c0-15.7-7.9-29.6-20-37.8h34.7c31.2,0,56.5-25.3,56.5-56.5C476,277.5,455.4,256.9,430,256.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.8,
    y: 351.4,
    className: "st2",
    width: 15.8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.3,
    y: 394.5,
    className: "st2",
    width: 15.8,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M227.3,394.5h-97.1c-2.2,0-4,1.8-4,4s1.8,4,4,4h97.1c2.2,0,4-1.8,4-4S229.5,394.5,227.3,394.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.ee386a217f14ed928af993c71138e70f.svg";
export { ForwardRef as ReactComponent };